import { ValidatorErrorFormat } from './default-form-errors-formatter.types';

const formatter: ValidatorErrorFormat = {
  required: () => $localize`:Generyczny komunikat walidacji uzupełnienia pola formularza:Pole jest wymagane`,
};

export default formatter;
